import React,{Component} from 'react';
import './OrderConfirmation.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import OrderData from '../Components/OrderData/OrderData';
import axios from 'axios';
import {Link} from 'react-router-dom';
import {LinkAPI} from '../../API/API';
import HandleRes from '../Components/HandleRes/HandleRes';

class OrderConfirmation extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reciver: "",
            phone: "",
            deliverynote: "",
            weight: "",
            pickupdate: "",
            quantity:"",
            pickupaddress_name:"",
            dropoffaddress_name:"",
            orderPrice:'',
            status:'',
            failedstatus:0,
            totalPrice:'',
            ordernumber:'',
        };
        this.getorderid()
    }

    getorderid=()=>{
        const Token =localStorage.getItem("userToken")
        const id = this.props.match.params.id
        axios.get(`${LinkAPI}/api/businessowner/getorder/${id}`,{
            headers:{
              Authorization:`${Token}`
            }
          }).then(res =>{
            if(res.data){

            this.setState({
                reciver: res.data.reciver.name, 
                phone:res.data.reciver.phone,
                quantity:res.data.quantity,
                ordernumber:res.data.ordernumber,
                deliverynote:res.data.note,
                date: res.data.date,
                pickupdate: res.data.pickupDate,
                pickupaddress_name:res.data.pickupLocation.address_name,
                dropoffaddress_name:res.data.dropoffLocation.address_name,
                totalPrice:res.data.totalPrice,
                status:res.data.status,
                failedstatus:res.data.failedstatus,

                amount:res.data.amount,
                qrcode:res.data.qrcode

              })
            }else{
              window.location.replace("/NotFound");
  
          }
              }).catch(error=>{
              if (!error.response) {
                this.setState({
                  networkError: true
                })
              } else if (error.response.status === 402) {
                window.location.replace("/SignIn");
              } else if (error.response.data.message) {
                this.setState({

                  errordatamessage: true,
                  errordatamessagetext: error.response.data.message
                })
              } else {
                this.setState({
                  hasError: true,
                })
              }
              })

    }
    render(){
      document.title ="Kayn | Order Confirmation"; 
      document.getElementsByTagName("META")[1].content="Kayn Order Confirmation";
          document.documentElement.lang = 'en';

        return(
            <div>
                <div className="AppEN client container-fluid px-0">
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                            <NabarClient />
                        </div>
                        <div className="OrderConfirmation col-md-11 px-lg-5">
                            <HeaderTool />
                            <div className="col-md-7  borderOrderConfirmation shadow mx-auto">
                            <h3 className=" fontsize9 my-2">Order Confirmation</h3>
                            <h3 className=" fontsize10 my-2 font-weight-bold bluecolor">THANK YOU !</h3>
                          
                            <OrderData state={this.state}/>
                            <div className="text-center d-flex justify-content-around  flex-wrap my-3">
                                    <Link to="/NewOrder" className="bg-white badge-pill p-2 pl-1 px-3 border shadow bluebg">CREATE NEW ORDER</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default OrderConfirmation;